// ArChat Plans Translation
// Created: 14-03-2026 16:10:30
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';

export const plansTranslationsSv = {
  ...plansTranslationsEn,
  'plans.compare.pro.adjustment_notice': 'Priset kan justeras enligt tjänstens villkor.',
  'plans.compare.title': 'Välj din plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 begränsade platser',
  'plans.compare.cta.foundation': 'Bli Founder',
  'plans.compare.cta.pro': 'Uppgradera till PRO',
  'plans.compare.active': 'Nuvarande plan',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Meddelandegräns uppnådd',
  'plans.limit.message.messages': 'Du har nått meddelandegränsen för din plan. Uppgradera till FOUNDATION eller PRO.',
  'plans.limit.title.storage': 'Lagringsgräns uppnådd',
  'plans.limit.message.storage': 'Du har nått lagringsgränsen. Uppgradera för att ladda upp fler filer.',
  'plans.limit.title.invitations': 'Inbjudningsgräns uppnådd',
  'plans.limit.message.invitations': 'Du har nått inbjudningsgränsen. Uppgradera för att bjuda in fler.',
  'plans.founder.remaining': '{count} Founder-platser kvar',
  'plans.founder.remaining_last': 'Sista {count} Founder-platserna',
  'plans.founder.remaining_limited': 'Begränsat: {count} platser kvar',
  'plans.founder.remaining_very_low': 'Bara {count} Founder-platser kvar',
  'plans.founder.soldout': 'Founder är slutsåld',
  'plans.limit.reached': 'Gräns uppnådd — Uppgradera plan',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'Uppgradera plan',
  'plans.modal.comparison_title': 'Planjämförelse',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Gratisplan',
  'plans.free.price': '$0 / månad',
  'plans.free.features.contacts': 'Högst 2 kontakter per användare',
  'plans.free.features.conversations': 'Högst 2 aktiva konversationer per konto',
  'plans.free.features.no_export': '30 000 tecken/månad per konto; 34 meddelanden/dag och 1 000/månad; ingen export',
  'plans.free.features.no_advanced': 'Inga filer eller lagring; 30 dagars historik; 1 enhet per användare',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder-plan',
  'plans.foundation.features.contacts': 'Samma premiumavtal som PRO (högst 100 kontakter per användare)',
  'plans.foundation.features.conversations': 'Obegränsade chattar (tenant); samma gränser som PRO',
  'plans.foundation.features.badge': 'Founder-program (150 numrerade platser)',
  'plans.foundation.features.support': 'USD 15/månad så länge Founder-platser finns',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro-plan',
  'plans.pro.features.contacts': 'Högst 100 kontakter per användare',
  'plans.pro.features.conversations': 'Obegränsade chattar (tenant); 1 667 meddelanden/dag, 50k/månad',
  'plans.pro.features.export': 'Högst 50 MB (tenant); export, översättning och filer enligt plan',
  'plans.pro.features.notifications': 'Högst 3 enheter per användare; obegränsade inbjudningar (tenant)',
  'plans.actions.free': 'Nuvarande plan',
  'plans.actions.foundation': 'Bli Founder',
  'plans.actions.pro': 'Uppgradera till PRO',
  'plans.badges.recommended': 'REKOMMENDERAD',
  'plans.badges.limited': 'BEGRÄNSAD',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': '30 000 tecken per månad per konto.',
  'plans.modal.free.line2': 'Upp till 2 kontakter per användare.',
  'plans.modal.free.line3': 'Upp till 2 aktiva konversationer per konto.',
  'plans.modal.free.line4': 'Inga bilagor eller lagringsutrymme.',
  'plans.modal.free.line5': 'Ingen dataexport.',
  'plans.modal.free.line6': 'Meddelandehistorik upp till 30 dagar.',
  'plans.modal.free.line7': 'Endast 1 enhet per användare.',
  'plans.modal.premium.line1': '300 000 tecken per månad per konto.',
  'plans.modal.premium.line2': 'Upp till 100 kontakter per användare.',
  'plans.modal.premium.line3': 'Obegränsade konversationer och chattar (tenant).',
  'plans.modal.premium.line4': 'Upp till 50 MB lagring (tenant).',
  'plans.modal.premium.line5': 'Upp till 3 enheter per användare.',
  'plans.modal.premium.line6': 'Obegränsade inbjudningar (tenant).',
  'plans.modal.premium.line7': 'Inkluderar export, automatisk översättning och filer inom planens gränser.',
  'plans.modal.premium_block_heading': 'Motorns användningsgränser (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder-program',
  'plans.modal.foundation.categories_title': 'Founder-kategorier ({slots} platser)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Position 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'De första som stödde projektet. Högsta historiska prioritet.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Position 26–75',
  'plans.modal.foundation.cat_early_desc': 'Tidigt stöd med särskilt erkännande.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Position 76–150',
  'plans.modal.foundation.cat_std_desc': 'Founder-plats inom de 150 positionerna.',
  'plans.modal.foundation.advantages_title': 'Founder-fördelar',
  'plans.modal.foundation.adv1': 'Tillgång till den begränsade Founder-poolen ({slots} numrerade platser).',
  'plans.modal.foundation.adv2': 'Erkännande som grundande användare av ArChat.',
  'plans.modal.foundation.adv3': 'Founder-märke och närvaro i produktupplevelsen.',
  'plans.modal.foundation.adv4': 'Historisk prioritet och status baserat på din position (1–150).',
  'plans.modal.foundation.adv5': 'Löpande fördel kopplad till din Founder-tillgång medan gällande policy tillämpas.',
  'plans.modal.pro.tagline': 'Standard premium — utan Founder-komponent',
  'plans.payments_disabled.title': 'Prenumerationer',
  'plans.payments_disabled.message': 'Prenumerationer aktiveras gradvis. Du kan se tillgängliga planer och deras fördelar.',
  'plans.payments_disabled.confirm': 'OK',
};